<template>
  <div class="course-category">
    <van-collapse v-model="activeCategoryNames">
      <van-collapse-item name="1">
        <template #title>
          <div class="title-container">
            <div class="chapter-title">理论课程</div>
          </div>
        </template>
        <div class="chapter-content">
          <div class="triangle-left"></div>
          <div class="triangle-right"></div>
          <template v-for="(chapter, index) of courseCategoryData">
            <div class="chapter-tasks" v-if="chapter" :key="chapter.id ? chapter.id : index" :name="chapter.id">
              <course-category-task :task-data="chapter" @taskClick="taskClick"></course-category-task>
            </div>
          </template>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import CourseCategoryTask from './CourseCategoryTask.vue'
export default {
  name: 'CourseCategory',
  components: {
    CourseCategoryTask
  },
  props: {
    courseCategoryData: {
      type: Array
    }
  },
  watch: {
  },
  data() {
    return {
      activeCategoryNames: ['1']
    }
  },
  mounted() {
  },
  methods: {
    taskClick (task) {
      this.$emit('switchTask', task)
    }
  }
}
</script>

<style lang="less" scoped>
.course-category {
  padding: 16px 12px 0;
  /deep/ .van-cell {
    line-height: normal;
    display: flex;
    align-items: center;
  }
  .title-container {
    display: flex;
    align-items: center;
    .chapter-title {
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      color: #1f333f;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .chapter-content {
    position: relative;
    .triangle-left {
      position: absolute;
      left: -5px;
      width: 5px;
      height: 5px;
      background: #999999;
      background: linear-gradient(45deg, transparent, transparent 50%, #999 51%, #999 100%);
    }
    .triangle-right {
      position: absolute;
      right: -5px;
      width: 5px;
      height: 5px;
      background: linear-gradient(-45deg, transparent, transparent 50%, #999 51%, #999 100%);
    }
  }
  .chapter-tasks {
    padding: 0 12px;
  }
  /deep/ .van-collapse-item {
    /*margin-bottom: 15px;*/
  }
  /deep/ .van-cell {
    height: 44px;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 12px;
  }
  /deep/ .van-collapse-item__title--expanded {
    overflow: auto;
    border-radius: 12px 12px 0 0;
  }
  /deep/ .van-collapse-item__content {
    margin: 0 5px;
    padding: 0;
    background: #fff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 0 0 5px 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/CourseCategory.vue